"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const PriceGroup_1 = tslib_1.__importDefault(require("./PriceGroup"));
const class_validator_1 = require("class-validator");
const ConsumptionPrice_1 = tslib_1.__importDefault(require("./ConsumptionPrice"));
const YearlyMonthlyValue_1 = tslib_1.__importDefault(require("./YearlyMonthlyValue"));
let GetTariffsResponseProduct = class GetTariffsResponseProduct extends base_models_1.Serializable {
};
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => YearlyMonthlyValue_1.default),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", YearlyMonthlyValue_1.default)
], GetTariffsResponseProduct.prototype, "totalPrice", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({ example: 'G_H_BD', description: 'Name of the product' }),
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", String)
], GetTariffsResponseProduct.prototype, "name", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Type)(() => PriceGroup_1.default),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", Array)
], GetTariffsResponseProduct.prototype, "priceGroups", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Type)(() => ConsumptionPrice_1.default),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", Array)
], GetTariffsResponseProduct.prototype, "consumptionPrices", void 0);
GetTariffsResponseProduct = tslib_1.__decorate([
    (0, class_transformer_1.Exclude)()
], GetTariffsResponseProduct);
exports.default = GetTariffsResponseProduct;
